import { css } from '@emotion/react'
import { DropdownItem, Flow, ModalSidebar, ModalSidebarPosition, Text, Theme, useTheme } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { AlertaSuporteDecisaoClinica } from 'hooks/sdc/model-sdc'
import { useAlertasSdc } from 'hooks/sdc/useAlertasSdc'
import { useEffect } from 'react'
import { scrollAndFocusElement, ScrollOptions } from 'util/scroll'

import { SdcAvisosCard } from './SdcAvisosCard'

interface SdcDetalhesModalSideMenuProps {
  alertaSelecionado: AlertaSuporteDecisaoClinica
  position: ModalSidebarPosition
}

const SCROLL_CONFIG: ScrollOptions = {
  delay: 300,
  motionDurations: [
    { maxDistance: 400, duration: 200 },
    { maxDistance: 800, duration: 500 },
  ],
  motionMaxDuration: 700,
}

export const SdcDetalhesModalSideMenu = (props: SdcDetalhesModalSideMenuProps) => {
  const { alertaSelecionado, position } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const { alertasSdcVisiveis, marcarTodosAlertasComoLidos, setAlertaSelecionado } = useAlertasSdc()

  useEffect(() => {
    if (!alertaSelecionado?.id) return
    scrollAndFocusElement(`alerta-card-${alertaSelecionado.id}`, SCROLL_CONFIG)
  }, [alertaSelecionado?.id])

  return (
    <ModalSidebar position={position} style={styles.container}>
      <Flow direction='horizontal' alignItems='center' justifyContent='space-between' style={styles.header}>
        <Text fontWeight='bold'>Notificações disparadas</Text>
        <DropdownButton isInsideModal>
          <DropdownItem onClick={marcarTodosAlertasComoLidos}>Marcar todos como lidos</DropdownItem>
        </DropdownButton>
      </Flow>

      <Flow direction='vertical' gap={0.5} style={styles.alertsList}>
        {alertasSdcVisiveis.map((alerta) => (
          <div key={alerta.id} id={`alerta-card-${alerta.id}`}>
            <SdcAvisosCard
              alerta={alerta}
              onClick={setAlertaSelecionado}
              selecionado={alerta.id === alertaSelecionado.id}
            />
          </div>
        ))}
      </Flow>
    </ModalSidebar>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    padding: 1.5rem 0 2rem 1rem;
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  header: css`
    padding-bottom: 0.5rem;
    padding-right: 1rem;
    height: fit-content;
  `,
  alertsList: css`
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 1rem;

    > div {
      width: 100%;
    }

    ::-webkit-scrollbar {
      width: 0.25rem;
    }
    ::-webkit-scrollbar-track {
      background-color: ${theme.pallete.gray.c90};
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 1rem;
      background-color: ${theme.pallete.gray.c70};
    }
  `,
})
